import React from "react";
import Slider from "react-slick";
import "./Team.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const teamMembers = [
  { img: "team.webp", name: "Yoni Albert", position: "Supporter" },
  { img: "team.webp", name: "Christine Eve", position: "Consultant" },
  { img: "team.webp", name: "David Hardson", position: "Consultant" },
  { img: "team.webp", name: "Sneha Rao", position: "Supporter" },
  { img: "team.webp", name: "Ankit Sharma", position: "Consultant" },
  { img: "team.webp", name: "Priya Mehta", position: "Consultant" },
];

const Team = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "80px",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      },
    ],
  };

  return (
    <section className="team-section">
      <div className="team-container">
        <p className="team-subheading">✈ OUR GUIDE</p>
        <h1 className="team-heading">Meet Our Experience Guide</h1>

        <Slider {...settings} className="team-slider">
          {teamMembers.map((member, index) => (
            <div className="team-slide" key={index}>
              <div className="team-card">
                <img
                  src={require(`./${member.img}`)}
                  alt={member.name}
                  className="team-img"
                  loading="lazy"
                />
                <div className="team-card-footer">
                  <div className="footer-orange"></div>
                  <div className="footer-blue">
                    <h3>{member.name}</h3>
                    <p>{member.position}</p>
                  </div>
                </div>
                <div className="social-icon-wrapper">
                  <ul className="social-icons">
                    <li>
                      <i className="fab fa-facebook-f"></i>
                    </li>
                    <li>
                      <i className="fab fa-twitter"></i>
                    </li>
                    <li>
                      <i className="fab fa-instagram"></i>
                    </li>
                    <li>
                      <i className="fab fa-pinterest"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Team;
